import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Form, FormGroup, Button, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { resetPassword } from "../../api/auth";
import Logo from "../../assets/img/HT-Logo-Wordmark.svg";
import "./login.scss";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = e.target.elements.email.value;

    if (!email) {
      toast.error("Email cannot be empty!");
      return;
    }

    setLoading(true);

    try {
      const response = await resetPassword({
        username: email,
        source: window.location.origin,
      });

      if (response?.body) {
        toast.success(response.body);
        // Optionally navigate back to login after successful request
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (error) {
      console.error("Reset password error:", error);
      toast.error("Failed to send reset password email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "3rem" }} className="wrapper fadeInDown">
      <div id="formContent">
        <div className="fadeIn first">
          <img src={Logo} id="icon" alt="User Icon" />
        </div>

        <br />

        <Form className="login-container-padding" onSubmit={handleSubmit}>
          <FormGroup>
            <Input
              readOnly={loading}
              type="text"
              id="email"
              className="fadeIn second"
              name="email"
              placeholder="Email Id"
            />
          </FormGroup>

          <Button
            type="submit"
            className="fadeIn fourth"
            color="primary"
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Reset Password"}
          </Button>
        </Form>

        <div id="formFooter">
          <Button
            className="underlineHover"
            onClick={() => navigate("/login")}
            color="link"
          >
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
